import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import equipeImg from '../assets/equipe.jpg'
const QuiSommesNous = () => {
  return (
    <>
      <Helmet>
        <title>Qui sommes-nous - ZiExter | Call Center & BPO en Tunisie</title>
        <meta
          name="description"
          content="ZiExter : une équipe internationale et multilingue basée en Tunisie. +15 pays, +500 projets, 98% de satisfaction. Made with 🌶️ piments."
        />
        <link rel="canonical" href="https://ziexter.com/qui-sommes-nous" />
      </Helmet>

      {/* Hero with split layout */}
      <section className="relative bg-gradient-to-br from-secondary to-primary text-white overflow-hidden">
        <div className="container-custom py-12 md:py-20">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Text Content */}
            <div className="animate-fade-in-up">
              <h1 className="font-heading text-4xl md:text-5xl font-bold mb-6 leading-tight">
                Qui sommes-nous ?
              </h1>
              <p className="text-lg md:text-xl text-white/90 mb-4">
                Les vraies stars ici, ce sont vos futurs collaborateurs. Oui, chez ZiExter, ce sont eux qui font toute la différence.
              </p>
              <p className="text-lg md:text-xl text-white/90 mb-4">
                Des stars ? 🌟 C'est peu dire.
              </p>
              <p className="text-base md:text-lg text-white/80">
                Tous nos agents sont les héros de vos clients, formés à l'excellence et capables de jongler entre plusieurs langues et cultures. Avec une qualité de service qui dépasse les standards, nous sommes fiers de vous montrer une partie de vos équipes.
              </p>
            </div>

            {/* Image Content */}
            <div className="animate-fade-in-up animation-delay-100 relative h-96 md:h-full">
              <div className="relative h-full rounded-lg overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-300">
                <img
                  src= {equipeImg}
                  alt="L'équipe ZiExter"
                  className="w-full h-full object-cover"
                  loading="eager"
                />
                {/* decorative overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>
              {/* floating decorative element */}
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-white/10 rounded-full blur-3xl" />
            </div>
          </div>
        </div>

    
      </section>

     {/* Chiffres clés */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="section-title">Chiffres clés</h2>
            <p className="text-gray-600">Nos résultats parlent pour nous</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="card p-8 text-center hover-lift">
              <div className="w-16 h-16 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="text-5xl font-bold text-primary mb-2">92%</div>
              <div className="text-gray-600">Taux de présentéisme de nos collaborateurs (vs 83% sur le marché)</div>
            </div>

            <div className="card p-8 text-center hover-lift">
              <div className="w-16 h-16 bg-accent bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <div className="text-5xl font-bold text-accent mb-2">1.1M+</div>
              <div className="text-gray-600">Interactions clients gérées en 2024 (appels, tickets, chat, email)</div>
            </div>

            <div className="card p-8 text-center hover-lift">
              <div className="w-16 h-16 bg-secondary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
              </div>
              <div className="text-5xl font-bold text-secondary mb-2">83+</div>
              <div className="text-gray-600">Cafés et thés servis chaque jour dans nos bureaux</div>
            </div>
          </div>
        </div>
      </section>

      {/* Témoignages de nos collaborateurs */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="section-title">Témoignages de nos collaborateurs</h2>
            <p className="text-gray-600">Voici ce qu'ils disent vraiment de ZiExter</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="card p-6 border-l-4 border-primary hover-lift">
              <div className="flex items-start mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="italic text-gray-700 mb-4">
                "L'ambiance chez ZiExter est incroyable, ici je me sens écoutée et valorisée. C'est ce qui me motive à donner le meilleur pour chaque client."
              </p>
              <div className="font-semibold text-primary">Sami</div>
              <div className="text-sm text-gray-600">Agent Inbound</div>
            </div>

            <div className="card p-6 border-l-4 border-accent hover-lift">
              <div className="flex items-start mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="italic text-gray-700 mb-4">
                "Je suis fier de travailler sur des projets internationaux depuis la Tunisie. C'est motivant de savoir que notre voix porte jusqu'en France et ailleurs."
              </p>
              <div className="font-semibold text-primary">Houda</div>
              <div className="text-sm text-gray-600">Téléconseillère Outbound</div>
            </div>

            <div className="card p-6 border-l-4 border-secondary hover-lift">
              <div className="flex items-start mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="italic text-gray-700 mb-4">
                "Le climat bienveillant et l'esprit d'équipe ici me donnent envie de venir travailler avec le sourire chaque matin."
              </p>
              <div className="font-semibold text-primary">Maroua</div>
              <div className="text-sm text-gray-600">Back-office Support</div>
            </div>

            <div className="card p-6 border-l-4 border-primary hover-lift">
              <div className="flex items-start mb-4">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
              </div>
              <p className="italic text-gray-700 mb-4">
                "J'adore relever des défis quotidiens et apprendre en continu. ZiExter nous offre cet environnement d'évolution."
              </p>
              <div className="font-semibold text-primary">Fayçal</div>
              <div className="text-sm text-gray-600">Superviseur</div>
            </div>
          </div>
        </div>
      </section>

      {/* Avantages employés */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="section-title">Avantages employés</h2>
            <p className="text-gray-600">Des collaborateurs heureux = des clients heureux</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-primary bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <strong>Bureaux spacieux et modernes</strong>
              <p className="text-gray-600 text-sm mt-2">Ksibet El Mediouni</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-accent bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <strong>Salle de sport</strong>
              <p className="text-gray-600 text-sm mt-2">Garder l'énergie</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-secondary bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v18m9-9H3" />
                </svg>
              </div>
              <strong>Fruits & snacks</strong>
              <p className="text-gray-600 text-sm mt-2">À volonté</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-primary bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <strong>Café & thé</strong>
              <p className="text-gray-600 text-sm mt-2">À volonté</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-accent bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m0 0l-2-1m2 1v2.5M14 4l-2 1m0 0l-2-1m2 1v2.5" />
                </svg>
              </div>
              <strong>Sorties d'équipe</strong>
              <p className="text-gray-600 text-sm mt-2">Toutes les 2 semaines</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-secondary bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <strong>Gamification</strong>
              <p className="text-gray-600 text-sm mt-2">Points & cadeaux</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-primary bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <strong>Formations continues</strong>
              <p className="text-gray-600 text-sm mt-2">Progression quotidienne</p>
            </div>

            <div className="card p-6 text-center hover-lift">
              <div className="w-12 h-12 bg-accent bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <strong>Application employé</strong>
              <p className="text-gray-600 text-sm mt-2">En un clic</p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg p-8 text-center">
            <h3 className="text-xl font-semibold mb-2">Une question ? Nous sommes là.</h3>
            <p className="text-gray-600 mb-6">Contactez notre équipe RH pour plus d'informations</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/contact" className="btn btn-primary">Nous contacter</Link>
              <Link to="/faq" className="btn btn-outline">Questions fréquentes</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Cofondateurs */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="section-title">Les cofondateurs</h2>
            <p className="text-gray-600">Derrière ZiExter, une passion pour l'excellence</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="card p-8 hover-lift">
              <div className="w-16 h-16 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Prénom Nom</h3>
              <p className="text-primary font-medium text-sm mb-4">CEO & Co-Founder 🇫🇷🇹🇳</p>
              <p className="text-gray-600 mb-6">
                Ancien directeur service client chez Deliveroo, avec plus de 20 équipes créées en France, Madagascar et Tunisie. A dirigé jusqu'à 350 collaborateurs et contribué à la croissance de plusieurs startups.
              </p>
              <Link to="/contact" className="btn btn-accent btn-sm w-full">Prendre RDV</Link>
            </div>

            <div className="card p-8 hover-lift">
              <div className="w-16 h-16 bg-accent bg-opacity-10 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Prénom Nom</h3>
              <p className="text-accent font-medium text-sm mb-4">COO & Co-Founder</p>
              <p className="text-gray-600 mb-6">
                Ancien directeur des opérations chez Orange Madagascar, spécialiste en pilotage de grandes équipes (500+ personnes) et expert en externalisation offshore.
              </p>
              <Link to="/contact" className="btn btn-accent btn-sm w-full">Prendre RDV</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Final brand + CTA */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <h3 className="text-3xl font-bold mb-4">ZiExter – Humain, Qualité & Piment Tunisien</h3>
          <p className="text-lg text-gray-700 mb-8">
            La nouvelle génération de l'externalisation de la relation client. Made with passion in Tunisia 🇹🇳
          </p>
          <Link to="/contact" className="btn btn-primary btn-lg">Planifiez une consultation avec nous</Link>
        </div>
        </section>

      {/* CTA */}
      <section className="section-padding bg-gradient-to-r from-primary to-secondary text-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6">
              Prêt à travailler avec nous ?
            </h2>
            <p className="text-xl text-gray-100 mb-8">
              Découvrez comment ZiExter peut transformer votre service client et vos opérations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/devis" className="btn btn-accent btn-lg">
                Demandez un devis gratuit
              </Link>
              <Link to="/contact" className="btn btn-outline-white btn-lg">
                Contactez-nous
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QuiSommesNous;

